import styled from "styled-components";

const LabelStyles = styled.label`
  font-style: normal;
  font-weight: ${({ theme }) => theme.typography.label.weight};
  font-size: ${({ theme }) => theme.typography.label.size};
  line-height: ${({ theme }) => theme.typography.label.lineHeight};
  color: ${({ theme }) => theme.colors.semantic.text.strong};
`;

const Label = ({ children, className, style }) => (
  <LabelStyles className={className} style={{ ...style }}>
    {children}
  </LabelStyles>
);

export default Label;
